import { SkeletonLoader } from '../SkeletonLoader';

/** Loading placeholder matching the profile page layout. */
export const StaffProfileSkeleton = () => (
  <div className="space-y-4" aria-busy="true" aria-label="Loading staff profile">
    <div className="glass-card p-4 md:p-6 flex items-center gap-4">
      <SkeletonLoader className="w-16 h-16 rounded-xl" />
      <div className="flex-1 space-y-2">
        <SkeletonLoader className="h-8 w-1/3" />
        <SkeletonLoader className="h-4 w-1/2" />
      </div>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      {Array.from({ length: 5 }, (_, i) => (
        <SkeletonLoader key={i} className="h-20" />
      ))}
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <SkeletonLoader className="h-48" />
      <SkeletonLoader className="h-48" />
    </div>
  </div>
);
